import { render, staticRenderFns } from "./ConventionTeaserSmall.vue?vue&type=template&id=274bdec4&scoped=true"
import script from "./ConventionTeaserSmall.vue?vue&type=script&lang=js"
export * from "./ConventionTeaserSmall.vue?vue&type=script&lang=js"
import style0 from "./ConventionTeaserSmall.vue?vue&type=style&index=0&id=274bdec4&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274bdec4",
  null
  
)

export default component.exports